module.exports = __webpack_public_path__ + "static/media/banner1.7c424e20.png";